/**
 * Simple debounce function that delays the execution of a callback
 * @param callback The function to debounce
 * @param delay The delay in milliseconds
 * @returns A debounced version of the callback function
 */
export const debounce = <T extends (...args: any[]) => any>(callback: T, delay: number): T => {
  let timeoutId: NodeJS.Timeout;

  return ((...args: Parameters<T>) => {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      callback(...args);
    }, delay);
  }) as T;
};
